import type { Easing } from 'motion/react'

export const MENU_DURATION = 0.25
export const OVERLAY_DURATION = 0.25

export const EASE_IN_OUT_QUAD = [0.45, 0, 0.55, 1] satisfies Easing

export const EASE_OUT_CUBIC = [0.33, 1, 0.68, 1] satisfies Easing
